<template>
	<div class="vote">
		<div class="wrap">
			<div class="title">Голосование завершено</div>
			<div class="text">
				От тебя зависело, как в преддверии праздников будет #боржомить Маша Новосад. Все мнения учтены, осталось только
				<a
					href="https://www.instagram.com/marienovosad/?hl=ru"
					target="_blank"
				>посмотреть</a> и вдохновиться тем, как Маша будет проводить пижама-пати с настольными играми 28 декабря!
			</div>
			<div class="results">
				<div class="result">
					<div class="num">{{ results[0] }}%</div>
					<div class="about">Провести пижама-пати с настольными играми</div>
				</div>
				<div class="result">
					<div class="num">{{ results[1] }}%</div>
					<div class="about">Покататься с близкими и друзьями на катке</div>
				</div>
				<div class="result">
					<div class="num">{{ results[2] }}%</div>
					<div class="about">Погонять по ледяной реке на кайте</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import firebase from 'firebase/app'

export default {
	data() {
		return {
			selected: true,
			selecting: false,
			results: [0, 0, 0],
			rawResults: [0, 0, 0],
			uid: null,
		}
	},
	mounted() {
		//get results
		firebase
			.database()
			.ref('result')
			.on('value', snap => {
				this.rawResults = snap.val()
				this.convertResults(snap.val())
			})

		// firebase.auth().onAuthStateChanged(user => {
		// 	if (!user) return
		// 	this.uid = user.uid

		// 	firebase
		// 		.database()
		// 		.ref('user/' + user.uid)
		// 		.once('value')
		// 		.then(snap => {
		// 			let val = snap.val()
		// 			if (!val) this.selected = false
		// 			else this.selected = val
		// 		})
		// })
		// firebase
		// 	.auth()
		// 	.signInAnonymously()
		// 	.catch(err => {})
	},
	methods: {
		convertResults(raw) {
			let sum = raw[0] + raw[1] + raw[2]
			let r1 = Math.round((raw[0] * 100) / sum)
			let r2 = Math.round((raw[1] * 100) / sum)
			let r3 = Math.round((raw[2] * 100) / sum)
			let temp = r1 + r2 + r3
			if (temp > 100) {
				let diff = temp - 100
				r1 = r1 - diff
			}
			this.results = [r1, r2, r3]
		},
		doneSelect(res) {
			if (!this.uid) return (this.selected = true)

			ga('send', 'event', 'vote', res)

			firebase
				.database()
				.ref('user/' + this.uid)
				.set(res)

			firebase
				.database()
				.ref('result/' + res)
				.set(this.rawResults[res] + 1)

			if (this.selected) {
				firebase
					.database()
					.ref('result/' + this.selected)
					.set(this.rawResults[this.selected] - 1)
			}

			this.selected = res
		},
	},
}
</script>

<style scoped lang="less">
.vote {
	width: 3897px;
	height: 513px;
	background-image: url('../assets/hero.png');
	position: relative;
	background-position: 20% 20%;
}

.wrap {
	width: 500px;
	height: 300px;
	position: absolute;
	left: 56%;
	top: 30%;
	transform: translateX(-50%);
	color: #14817a;
}

.title {
	font-size: 30px;
	font-weight: bold;
	text-transform: uppercase;
}

.text {
	font-size: 15px;
	margin-top: 10px;

	a {
		display: inline-block;
		color: #14817a;
	}
}

.select {
	width: 340px;
	height: 60px;
	border: 1px solid #14817a;
	position: relative;
	box-sizing: border-box;
	margin: 0 auto;
	margin-top: 20px;
	cursor: pointer;

	.action {
		width: 100%;
		height: 60px;
		font-size: 20px;
		text-transform: uppercase;
		line-height: 60px;
		opacity: 0.5;
	}
	.options {
		width: 100%;
		position: absolute;
		top: 59px;
		left: -1px;
	}
	.option {
		width: 100%;
		height: 60px;
		display: flex;
		justify-content: center;
		align-items: center;
		text-transform: uppercase;
		background: #fff;
		border: 1px solid #14817a;
		border-top: none;
	}
	.option:hover {
		background: #14817a;
		color: #fff;
	}
}

.results {
	display: flex;
	justify-content: space-between;
	text-align: left;

	.num {
		color: #3ecfd0;
		font-size: 50px;
	}

	.about {
		font-size: 14px;
	}

	.result {
		width: 30%;
	}
}

@media only screen and (max-device-width: 640px),
	only screen and (max-device-width: 736px),
	only screen and (max-width: 480px) {
	.vote {
		width: 100%;
		height: auto;
		background-image: url('../assets/hero-mobile.png');
		background-position: center bottom;
		position: relative;
		padding-bottom: 425px;
	}

	.wrap {
		width: calc(100% - 40px);
		height: auto;
		position: relative;
		left: 0;
		top: 0;
		background-color: #fff;
		transform: translateX(0%);
		color: #14817a;
		padding: 30px 20px;
	}

	.select {
		width: 100%;
	}

	.results {
		padding-top: 20px;

		.num {
			color: #3ecfd0;
			font-size: 40px;
		}

		.about {
			font-size: 12px;
		}

		.result {
			width: 30%;
		}
	}
}
</style>
